import { resetServerContext } from 'react-beautiful-dnd'
import ListForm from '../../../../components/ListForm'

const EditListPage = ({ list, token }) => (
  <>
    <div className="mb3 mb4-ns mw7 w-100">
      <h2 className="f3 fw6 lh-copy mv0 tracked-light">
        {`Editing: ${list.title}`}
      </h2>
    </div>

    <ListForm action="update" savedList={list} token={token} />
  </>
)

export async function getServerSideProps(context) {
  const { slug, token } = context.params
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_HOSTNAME}/api/list/${slug}`
  )
  const data = await res.json()
  resetServerContext()

  if (!data.list || token != data.list.token) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      list: data.list || null,
      token,
    },
  }
}

export default EditListPage
